module.exports = __webpack_public_path__ + "img/course-background.415d75f5.jpg";